import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { formatDate, scrollToTop } from "../../constent/helper";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();

  const handleRead = (blog) => {
    if (blog?.tags?.blog_url) {
      navigate(`/blog-details/${blog?.tags?.blog_url}?blogId=${blog?.id}`, {
        state: { blog },
      });
    } else {
      navigate(`/blog-details/${blog?.id}?blogId=${blog?.id}`, {
        state: { blog },
      });
    }
    scrollToTop()
  };

  return (
    <div className="border border-gray-border h-full">
      <img
        src={blog?.attachments[0]?.file}
        alt={blog?.tags?.alt_text ? blog?.tags?.alt_text : blog?.title}
        className="w-full h-48 object-cover cursor-pointer "
        onClick={() => handleRead(blog)}
      />
      <div className="flex flex-col items-start justify-between gap-4 ">
      <div className="w-full">
      <div className="text-gray-600 justify-between flex items-center text-base mt-4 px-4 mb-1 ">
        <span className="text-sm text-gray-500 border border-gray-300 py-1.5 px-2.5 ">{blog?.tags?.keywords[0]}</span>
      <span>{formatDate(blog?.created_at)}{" "}</span>
      </div>
      <h2
        className="font-semibold text-2xl leading-9 text-justify cursor-pointer sm:px-4 px-4 "
        onClick={() => handleRead(blog)}
      >
        {blog?.title}
      </h2>
      </div>
      <div className="mb-4 px-4 text-primary-green cursor-pointer font-medium flex items-center text-sm gap-1" onClick={()=>handleRead(blog)}>
        Read More
        <FaArrowRight size={16}/>
      </div>
      </div>
    </div>
  );
};

export default BlogCard;
